import { getNews, postNews, putNews } from "../../api/news";
import { createSliceWithThunks } from "../utils";

const initialState = {
  get: {
    list: null,
    error: null,
    status: "idle",
  },
  post: {
    data: null,
    error: null,
    status: "idle",
  },
  put: {
    data: null,
    error: null,
    status: "idle",
  },
};

export const newsSlice = createSliceWithThunks({
  name: "news",
  initialState: initialState,
  reducers: (create) => ({
    resetStateNews: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),

    fetchNews: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getNews(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.get.status = "loading";
        },
        rejected: (state, action) => {
          state.get.status = "failed";
          state.get.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.get.error = { message: respObj };
            } else if (status === "success") {
              state.get.list = respObj;
            }
          } else {
            state.get.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.get.status = "idle";
        },
      }
    ),

    addNews: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postNews(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.post.status = "loading";
        },
        rejected: (state, action) => {
          state.post.status = "failed";
          state.post.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200 || status === 201) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.post.error = { message: respObj };
            } else if (status === "success") {
              state.post.data = respObj;
            }
          } else {
            state.post.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.post.status = "idle";
        },
      }
    ),

    updateNews: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await putNews(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.put.status = "loading";
        },
        rejected: (state, action) => {
          state.put.status = "failed";
          state.put.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200 || status === 201 || status === 202) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.put.error = { message: respObj };
            } else if (status === "success") {
              state.put.data = respObj;
            }
          } else {
            state.put.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.put.status = "idle";
        },
      }
    ),
  }),
});

export const { resetStateNews, fetchNews, addNews, updateNews } =
  newsSlice.actions;
export default newsSlice.reducer;
